import { PropsWithChildren } from 'react'
import classNames from 'classnames'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Motion from '@/components/base/Motion'

import { logoWallRevealAnimation } from './animations'
import { Section, WPImage } from '@/types'

type LogoWallProps = Section &
  Partial<{
    collection: {
      image: WPImage
    }[]
  }>

const LogoCard = ({
  className,
  children
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={classNames(className)} data-motion-logo>
      <span className="aspect-h-1 aspect-w-1 block">
        <span className="flex h-full w-full items-center justify-center rounded-xs bg-white p-gutter shadow-3xl">
          {children}
        </span>
      </span>
    </div>
  )
}

const LogoWall = ({ collection, ...props }: LogoWallProps) => {
  return (
    <Motion animation={logoWallRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-gutter">
              {collection?.map(({ image }, index) => (
                <LogoCard
                  key={`logo-${index}`}
                  className="col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-2"
                >
                  <Image
                    fit="contain"
                    size="large"
                    loading="lazy"
                    source={image}
                    alt={image?.alt}
                    className="h-full w-full object-contain"
                  />
                </LogoCard>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default LogoWall
